// extracted by mini-css-extract-plugin
export default {"cta":"Cta_cta__+Krpd","icon":"Cta_icon__pEyqg","disabled":"Cta_disabled__LmMJN"};